import AuthContent from "../../components/Auth"

const Auth = () => {
    
    return (
        <>
            
            <AuthContent />

        </>
    )

}

export default Auth